export const MAX_NUMBER_OF_TIME_INTERVALS = 4;

export enum DetailsFieldName {
    Name = 'name',
    ShortName = 'shortName',
    Description = 'description',
    Ordering = 'ordering',
    RateGroupKey = 'rateGroupKey',
}

export enum SettlementConfigurationsFieldName {
    MaximumTime = 'maximumTime',
    Extent = 'extent',
    Options = 'options',
}

export enum DefaultPolicyFieldName {
    SettlementRules = 'settlementRules',
    CancellationFees = 'cancellationFees',
}

export enum RateGroupFieldName {
    Details = 'details',
    SettlementConfigurations = 'settlementConfigurations',
    DefaultPolicy = 'defaultPolicy',
}
